import { LibraryModule as CIPLibrary } from './index'
import { SearchOnlyModule } from './src-search/index'
// import { LibraryModule as CIPLibrary } from './index'
import 'sd-cip-module-client/dist/index.css'
import { Profiler, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import {  useLocation, useHistory } from 'react-router-dom'
import { default as env, default as env_variables } from '../../../../config/env_variables'
// import { onRenderCB } from '../../../../helpers/widget-performance-analytics'
import {
  addMessage,
  getClosedConversationSummary,
  setConversationSentiments,
  setOutBoundCall,
  updateConversationSummaryFeedback
} from '../../../../redux/actions/contactCenterActions'
import {
  CHANGE_CUSTOMER,
  CHANGE_CUSTOMER_CONTACT,
  CHANGE_CUSTOMER_RENGA_ID,
  CLICK_PHONE_NUMBER,
  CONVERSATION_SUMMARY_FEEDBACK
} from '../../../../redux/constants/changeCustomerConstants'
import { RootState } from '../../../../redux/reducers/rootReducer'
import { getTranslationData } from '../../../ContactCenter/Api/api'
import { ContactRecord } from '../../../ContactCenter/Models'
import ContactCenter from '../../../ContactCenter/Modules/ContactCenter'
import { useAllowedAgent, useContextData } from '../../Hooks'
import './customerInfoPanel.scss'
import { enableRealTimeSentimentByQueueAndLdap } from '../../../../utils/fg-utils'

declare const window: any
const PHONE_ORIGIN = ['chat-to-phone', 'outbound-phone', 'inbound-phone', 'bot-to-phone']

interface Prop {
  CIP: boolean
}
interface State {
  widgetLayout: {
    widgets: { title: string; name: string; active: boolean }[]
    widgetStack: Record<string, any>
  }
  preferences: {
    darkMode: boolean
    language: string
  }
  contactCenter: {
    currentConversation: ContactRecord
    currentConversationAC: ContactRecord
    currentView: string
  }
}
interface URLS {
  HENDRIX_DOMAIN: string
  CM_DOMAIN: string
  CIP_DOMAIN: string
  CCP_API_END_POINT: string
  RTS_PROCESSOR_ENDPOINT: string
}

interface Message {
  message: string
  senderName: string
  sentBy: string
  timeStamp: string
}

const CustomerInfoPanel = ({ CIP }: Prop) => {
  const dispatch = useDispatch()
  const { darkMode, language } = useSelector((state: State) => state.preferences)
  const location = useLocation()
   const history = useHistory()
  const [showSummary, setshowSummary] = useState(false)
  const {
    agentDetails: { ldap: agentLdap = '' },
    conversationSummaries,
    conversationLegSentiments,
    conversationLegSentimentsLoading,
    currentConversationAC,
    currentConversation,
    currentView,
    transferInProgressId,
    enableRTS,
    toggleTranslationforCS,
    contactRTSentiments,
    enableMockOfferId
  } = useSelector((state: RootState) => state.contactCenter)
  console.log('##rts contactRTSentiments', contactRTSentiments, enableRTS)
  const conversation = currentView === 'AC_VIEW' ? currentConversationAC : currentConversation
  const { ocPlatformData: { chatInfo: { initialContactId = '', currentContactId = '', status: chatStatus = 'Active' } = {} } = {} } = conversation || {}

  const [conversationSummary, setConversatioSummary] = useState(conversationSummaries?.[currentContactId]?.summary)
  const [agentPath, setAgentPath] = useState(conversationSummaries?.[currentContactId]?.path ?? [])
  const [feedback, setFeedback] = useState(conversationSummaries?.[currentContactId]?.feedback)
  const { jcAuthData: { language: { value: conversationLanguage = '' } = {} } = {} } = conversation || {}

  const { jcAuthData, ocPlatformData, ocAppData, jcMidConvData } = useContextData()
  const contextData = { jcAuthData, ocPlatformData, ocAppData, jcMidConvData }
  const { currentQueue = '' } = contextData.jcAuthData || {}
  const isCIP = currentQueue.substring(0, 4) === 'SLS-' ? false : true
  const label = CIP ? 'CIP' : 'SCIP'
  const allowedAgent: any = useAllowedAgent(label)
  const { isSalesAgent = false } = allowedAgent
  contextData.ocPlatformData.allowedAgent = isSalesAgent
  contextData.ocPlatformData.transferInProgressId = transferInProgressId
  contextData.ocAppData.mockOfferIdFlag = enableMockOfferId
  const origin = contextData.ocAppData.originForCurrentConversation
  const isPhoneOrigin = PHONE_ORIGIN.includes(origin)
  const isChat = origin === 'inbound-chat' || origin === 'chat-to-phone'

  function callBackEventListener(eventType: string, eventData: any): void {
    console.log(`Received Event from Library : eventData =  ${JSON.stringify(eventData)}`)
    if (eventType === 'OFFER_PITCH_MESSAGE') {
      const data: any = {
        ParticipantRole: 'AGENT',
        translationText: eventData?.translateMsg
      }
      dispatch(addMessage(data))
      ContactCenter.sendMessage(conversation?.ocPlatformData.chatInfo?.currentContactId, eventData)
    } else if (eventType === 'CIP_PHONE_NUMBER_CLICK' && eventData) {
      if (location.pathname === '/history' ) history.push(`/chat${location.search}`)
      dispatch({ type: CLICK_PHONE_NUMBER, payload: eventData })
      if (!chatStatus || chatStatus === 'Closed') dispatch(setOutBoundCall(true))
    } else if (eventType === CONVERSATION_SUMMARY_FEEDBACK) {
      setFeedback(eventData)
      const data = { contactId: currentContactId, feedback: eventData, summary: conversationSummary, path: agentPath }
      dispatch(updateConversationSummaryFeedback(data))
    } else if (eventType === 'CIP_REPHRESH') {
      updateConversationSummaryInfo(conversation?.ocPlatformData?.chatTranscript ?? [])
    } else if (eventType === 'UPDATE_CUSTOMER_INFO') {
      console.log('UPDATE_CUSTOMER_INFO customer was changed', eventData)
      dispatch({ type: CHANGE_CUSTOMER_RENGA_ID, payload: eventData })
      dispatch({ type: CHANGE_CUSTOMER, payload: eventData })
      dispatch({ type: CHANGE_CUSTOMER_CONTACT, payload: { data: eventData, contactId: contextData?.ocPlatformData?.chatInfo?.currentContactId } })
    } else if (eventType === 'CHANGE_CUSTOMER_TOGGLE') {
      dispatch({ type: 'CHANGE_CUSTOMER_TOGGLE' })
    } else if (eventType === 'SET_SENTIMENTS') {
      dispatch(setConversationSentiments(eventData))
    }
  }

  const urls: URLS = {
    HENDRIX_DOMAIN: env.HENDRIX_DOMAIN,
    CM_DOMAIN: env.CM_DOMAIN,
    CIP_DOMAIN: env.CIP_DOMAIN,
    CCP_API_END_POINT: env.CCP_API_END_POINT,
    RTS_PROCESSOR_ENDPOINT: env.ENDPOINT_RTS_PROCESSOR
  }

  const getFastFollowFlags = () => {
    try {
      const localData: any = localStorage.getItem('fastFollowFlags')
      return JSON.parse(localData)?.FAST_FOLLOWS_GENAI_CONV_SUMMARY === true
    } catch (e) {
      console.log('fastFollowFlags fail', e)
      return false
    }
  }

  const updateConversationSummaryInfo = async (transcript: any[]) => {
    if (isChat && chatStatus === 'Closed' && !conversationSummaries?.[initialContactId]?.final) {
      await dispatch(getClosedConversationSummary(initialContactId, currentQueue, transcript))
    }
    //in case chat was transferred and page was reloaded
    //it is needed to recover summary of current conversation to display it
    if (isChat && chatStatus !== 'Closed' && !conversationSummaries?.[currentContactId]) {
      await dispatch(getClosedConversationSummary(currentContactId, currentQueue, transcript))
    }
  }

  useEffect(() => {
    updateConversationSummaryInfo(conversation?.ocPlatformData?.chatTranscript)
  }, [currentContactId])

  useEffect(() => {
    if (currentQueue && agentLdap && currentContactId) {
      enableRealTimeSentimentByQueueAndLdap(currentQueue, agentLdap)
        .then((enabled) => {
          dispatch({ type: 'SET_ENABLE_RTS', payload: { currentContactId, enabled } })
        })
        .catch((err) => console.log('Error checking if RTS is enabled by the queue and ldap: ', err))
    }
  }, [currentContactId, currentQueue, dispatch, agentLdap])

  useEffect(() => {
    const textsData = []
    const translationMap = {}
    const currentId = chatStatus === 'Closed' ? initialContactId : currentContactId
    const currentConversationSummary = conversationSummaries?.[currentId]?.summary ?? ''

    if (toggleTranslationforCS && currentConversationSummary) {
      const { main_issue = '', conversation_points = [], links } = currentConversationSummary
      console.log('CS: TRANSLATE NOW source language: ', conversationLanguage, 'Target language ', language)
      translationMap[uuidv4()] = {
        category: 'main_issue',
        preTranslationText: main_issue,
        postTranslationText: ''
      }
      conversation_points.forEach((point: any) => {
        translationMap[uuidv4()] = {
          category: 'conversation_points',
          preTranslationText: point,
          postTranslationText: ''
        }
      })

      Object.entries(translationMap).forEach(([key, value]: any) => {
        textsData.push({
          id: key,
          text: value.preTranslationText,
          doNotTranslate: false
        })
      })

      const fetchData = async () => {
        const request = {
          endpoint: env_variables.CCP_API_END_POINT,
          body: {
            sourceLanguage: conversationLanguage,
            targetLanguage: language,
            texts: textsData
          }
        }
        let customPanelAccessToken = ''
        if (localStorage.getItem('customPanelAccessToken')) {
          customPanelAccessToken = JSON.parse(localStorage.getItem('customPanelAccessToken') || '')
        }

        const headers = {
          Authorization: customPanelAccessToken,
          'x-api-key': 'oac-custom-panel'
        }

        const resp: any = await getTranslationData(request, headers)
        const {
          data: { texts: result = [] }
        } = resp?.data || {}

        result.forEach((element: any) => {
          const id = element.id
          const text = element.text
          translationMap[id].postTranslationText = text
        })

        //Update main_issue and conversation_points
        const updatedSummaryData = {
          main_issue: Object.values(translationMap)
            .filter((item: any) => item.category === 'main_issue')
            .map((item: any) => item.postTranslationText)
            .join(' '),
          conversation_points: Object.values(translationMap)
            .filter((item: any) => item.category === 'conversation_points')
            .map((item: any) => item.postTranslationText)
        }
        setConversatioSummary({ ...updatedSummaryData, links })
      }
      fetchData()
    } else {
      const currentConversationSummary = conversationSummaries?.[currentId]?.summary ?? undefined
      setConversatioSummary(currentConversationSummary)
    }
  }, [toggleTranslationforCS])

  useEffect(() => {
    let currentConversationSummary = undefined
    let fastFollowsGenAI = getFastFollowFlags()
    let currentId = ''
    try {
      currentId = chatStatus === 'Closed' ? initialContactId : currentContactId
      currentConversationSummary = conversationSummaries?.[currentId]?.summary ?? undefined
      setConversatioSummary(currentConversationSummary)
      const currentAgentPath = conversationSummaries?.[currentId]?.path ?? []
      setAgentPath(currentAgentPath)
      const currentFeedback = conversationSummaries?.[currentId]?.feedback ?? undefined
      setFeedback(currentFeedback)
    } catch (e) {
      console.log('Error: ', e)
      setConversatioSummary(null)
      setAgentPath([])
      setshowSummary(false)
    }
    if (fastFollowsGenAI && isChat && currentConversationSummary) {
      setshowSummary(true)
    } else {
      setshowSummary(false)
    }
  }, [currentContactId, conversationSummaries])

  const trendLineData = contactRTSentiments[currentContactId]?.transcriptSentiment || []


  if (!currentContactId) {
    return (
      <SearchOnlyModule
        baseUrl={urls.CIP_DOMAIN}
        darkMode={darkMode}
        language={language}
        contextData={contextData}
        callBackEvent={callBackEventListener}
      />
    )
  }

  return (
    <CIPLibrary
      contextData={contextData}
      feedback={feedback}
      conversationSummary={conversationSummary}
      conversationSentiments={conversationLegSentiments}
      conversationSentimentLoading={conversationLegSentimentsLoading}
      agentPath={agentPath}
      enableSummary={showSummary}
      sentimentEnabled={enableRTS[currentContactId] && !isPhoneOrigin}
      trendLineData={trendLineData}
      callBackEvent={callBackEventListener}
      darkMode={darkMode}
      CIP={isCIP}
      language={language}
      urls={urls}
    />
  )
}

export default CustomerInfoPanel
